import { constructEnum } from '@/lib/enum';

export default constructEnum('ReviewTag', {
  NEW: 'new',
  AFTER_USE_REVIEW: 'after_use_review',
  REORDER_REVIEW: 'reorder_review',
  MY_LAST_REVIEW: 'my_last_review',
  SHOW_PINNED_TO_TOP: 'show_pinned_to_top',
  WRITING_WHITELIST_REVIEW: 'writing_whitelist_review',
  PURCHASE_FOR_EXPERIENCE: 'purchase_for_experience',
  PURCHASE_FOR_GIFT: 'purchase_for_gift',
  REVIEW_VENDOR: 'review_vendor',
  EXTERNAL_PLATFORM_TYPE: 'external_platform_type',
  STORE_NAME: 'store_name',
  NTH_STEP_REVIEW: 'nth_step_review'
});
